import { flow } from '@hcr/utils'

import { createAccommodationGuests } from './createAccommodationGuests'
import { createGuestsString } from './createGuestsString'

export const createAccommodationGuestsString = flow(createAccommodationGuests, createGuestsString)
